import React, { useEffect, useState } from 'react'

import {
    // Box,
    Container,
    styled,
    Card,
    Chip,
    Button,
    Box,
    Link
} from '@mui/material';

import { useNavigate } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';

import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import DataGridTable from '../../common/DataGridTable';
import DataGridToolbar from '../../common/DataGridToolbar';

import { CommonIcons, icons } from '../../common/CommonIcons';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useDocuments, documentTypes, targetTypes } from '../../../hooks/api/useDocuments';
import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useAppContextFeatures } from '../../../context/AppContext';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, functionTypes, scopeTypes } from '../../../hooks/usePermissions';
import { useTranslations } from '../../../hooks/useTranslations';
import { useDependencies, dependencyModules, targetTypes as dependencyTargetTypes } from '../../../hooks/api/useDependencies';

const StyledCard = styled(Card)(({ theme }) => ({
    // padding: theme.spacing(4)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function ListRetailCashSales({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate();

    const { promptMessage } = useSystemPrompt();
    const { list, cancel } = useDocuments({ documentType: documentTypes.retailCashSales, targetType: targetTypes.retailCashSales});
    const { RenderDatagridDisplay: RenderDependencyDatagridDisplay } = useDependencies()

    const {
        defineColumns,
        defineRowMenuRender,
        columns,
        filterValues,
        getRenderColumnLink,
        getRenderColumnDateDisplay,
        getRenderColumnBooleanDisplay,
        getRenderColumnTextDisplay
    } = useDataGridParams('id')

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getLocationIds, openCustomDrawer } = useAppContextFeatures();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.retailCashSales.id)

    const gridRef = React.createRef();

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            // const result = await list({ ...props, customFilterLocationEnable: true, customFilterLocationField: 'location_id' })
            props.dataTypes = ["dependency"]

            props.customFilterLocationEnable = true;
            props.customFilterLocationFields = ['location_id']

            const result = await list(props)

            let rawData = result?.data?.documents

            let newData = []

            rawData.forEach(i => {

                let _i = i

                let outward = _i?.outward_dependencies
                let inward = _i?.inward_dependencies

                let all = [...outward, ...inward]

                // declare a value and allocate the combined data
                _i.all_dependencies = all

                newData.push(_i)
            })

            return {
                data: newData,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        setRefreshDataGrid(val => val + 1)

    }, [getLocationIds])


    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: "location_name",
                header: t("location"),
            },
            {
                name: "doc_number",
                header: t("docNo"),
                renderValue: ({ cellProps, value }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`documents/retailCashSales/view/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: "doc_date",
                header: t("docDate"),
                renderValue: ({ cellProps, value }) => getRenderColumnDateDisplay(value)
            },
            {
                name: "profile_name",
                header: t("profile"),
            },
            {
                name: "is_active_status",
                header: t("status"),
                textAlign: "center",
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Active", "Cancel"], ["primary", "default"], "")
            },
            {
                name: "is_post_stock",
                header: t("stockPosted"),
                textAlign: "center",
                renderValue: ({ cellProps, value }) => {

                    // if the row is cancelled
                    if (cellProps.data.is_active_status === "0") {
                        return (
                            <></>
                        )
                    }

                    // if the row is post stock
                    if (value === "1") {
                        return (
                            <Chip
                                size='small'
                                color='primary'
                                label={t(`posted`)}
                            />
                        )
                    }

                    return (
                        <Button
                            variant={'outlined'}
                            size='small'
                            onClick={() => {

                                if (isPermissionAllow({ functionType: functionTypes.pageStockPost.id })) {
                                    navigate(getRoute(`documents/retailCashSales/stockPost/${cellProps.data?.id}`))
                                }

                            }}
                        >
                            <CommonIcons name={icons.edit} />
                        </Button>
                    )

                    // getRenderColumnBooleanDisplay(value, ["Active", "Cancel"], ["primary", "default"], "")
                }
            },
            {
                name: 'all_dependencies',
                header: t('relatedDocs'),
                renderValue: ({ value, cellProps }) => {

                    return (
                        <RenderDependencyDatagridDisplay
                            id={cellProps.data.id}
                            values={value}
                            renderValue={({ id, otherUrl }) => {

                                if(otherUrl){
                                    return getRoute(otherUrl)
                                }
    
                                return getRoute(`documents/retailCashSales/view/${id}`)
                            }}
                        />
                    )

                }

            },
        ])
    }

    // const handleCancelOrder = async (data) => {

    //     try {
    //         console.log('data', data)
    //         const result = await cancel({ ids: [data?.id] })

    //         console.log('result', result)

    //         promptMessage(true, result?.message)
    //         setRefreshDataGrid(val => val + 1)

    //         resetDataGridTableSelection();

    //     } catch (error) {
    //         promptMessage(false, error?.message)
    //     }

    // }

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const handleCancel = async () => {

        try {
            const result = await cancel({ ids: selectedIds })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val + 1)

            resetDataGridTableSelection();

        } catch (error) {
            promptMessage(false, error?.message)
        }

    }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {
                        navigate(getRoute("documents/retailCashSales/new"));
                    }
                })
            }

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.cancel.id })) {
                handleFunction = handleCancel
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickCancel={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )

    }

    const RenderDataGridTable = () => {
        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        // minHeight: 600
                    },
                    // pageSizes: [20, 50, 100],
                    // defaultLimit: 10,
                    // defaultSkip: 0,
                    checkboxColumn:
                        isPermissionAllow({ functionType: functionTypes.cancel.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        // console.log('items selected : ', items)
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeTypes, title: headTitles.retailCashSales })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("retailCashSales")}
                breadcrumbs={[
                    {
                        displayText: t("retailCashSales"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
